import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { REDIRECT_URL } from '../../../../../app/shared/util/url-utils';

const SignupRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storedRedirect = localStorage.getItem(REDIRECT_URL);

    if (!storedRedirect) {
      if (location.state?.from?.pathname && location.state.from.pathname !== '/') {
        localStorage.setItem(REDIRECT_URL, location.state.from.pathname);
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const redirectTemp = urlParams.get('redirect');

        if (redirectTemp && (redirectTemp.includes('/join') || redirectTemp.includes('/copying'))) {
          localStorage.setItem(REDIRECT_URL, redirectTemp);
        }
      }
    }
    const utmParams = new URLSearchParams();
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(key => {
      const value = localStorage.getItem(key);
      if (value) {
        // persist for later pages
        localStorage.setItem(key, value);
        // forward to keycloak
        utmParams.append(key, value);
      }
    });
    const keycloakSignupURL = `https://auth.doyouhaveacase.ai/realms/do-you-have-a-case/protocol/openid-connect/registrations?client_id=${process.env.IS_DEV ? 'web_app' : 'web_app_prod'}&response_type=code&scope=openid%20profile%20email%20offline_access&redirect_uri=${window.location.origin}/signin&kc_locale=en&${utmParams.toString()}`;

    window.location.href = keycloakSignupURL;
  }, []);

  return null;
};

export default SignupRedirect;
